/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
/**
 * 
 * @export
 * @interface IActionResult
 */
export interface IActionResult {
    /**
     * 
     * @type {string}
     * @memberof IActionResult
     */
    $type?: IActionResultTypeEnum;
}


/**
 * @export
 */
export const IActionResultTypeEnum = {
    MicrosoftAspNetCoreMvcIActionResultMicrosoftAspNetCoreMvcAbstractions: 'Microsoft.AspNetCore.Mvc.IActionResult, Microsoft.AspNetCore.Mvc.Abstractions'
} as const;
export type IActionResultTypeEnum = typeof IActionResultTypeEnum[keyof typeof IActionResultTypeEnum];


/**
 * Check if a given object implements the IActionResult interface.
 */
export function instanceOfIActionResult(value?: unknown): value is IActionResult {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(IActionResultTypeEnum)[0];
}

export function IActionResultFromJSON(json: any): IActionResult {
    return IActionResultFromJSONTyped(json, false);
}

export function IActionResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): IActionResult {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        '$type': !exists(json, '$type') ? undefined : json['$type'],
    };
}

export function IActionResultToJSON(value?: IActionResult | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        '$type': value.$type,
    });
}

